module.exports = __webpack_public_path__ + "static/work-78973e1eb905b29dce0d3f230029f300.svg";